module.exports = __webpack_public_path__ + "img/full-line.9de3b8eb.svg";